import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
export var useReportCardStore = defineStore({
  id: 'reportCard',
  state: function state() {
    return {
      cards: [],
      hydrated: false,
      hydrating: false
    };
  },
  getters: {
    getCourseCard: function getCourseCard(state) {
      return function (course) {
        var id = course;
        if (_typeof(course) == 'object' && course.id) id = course.id;
        if (typeof id != 'string') return false;
        return state.cards.find(function (card) {
          if (_typeof(card.course) == 'object') return card.course.id == id;
          if (typeof card.course != 'string') return false;
          return card.course == id;
        });
      };
    },
    hasCertificate: function hasCertificate(state) {
      return state.cards.some(function (o) {
        return o.certificateId;
      });
    },
    getCourses: function getCourses(state) {
      return state.cards.filter(function (o) {
        return o.course.type != 'event';
      });
    },
    getEvents: function getEvents(state) {
      return state.cards.filter(function (o) {
        return o.course.type == 'event';
      });
    }
  },
  actions: {
    sort: function sort() {
      this.cards.sort(function (a, b) {
        return new Date(b.interactionDate) - new Date(a.interactionDate);
      });
    },
    add: function add(card) {
      if (this.cards.findIndex(function (item) {
        return item.id === card.id;
      }) < 0) {
        this.cards.push(card);
        this.sort();
      }
    },
    remove: function remove(card) {
      var index = this.cards.findIndex(function (item) {
        return item.id === card.id;
      });
      if (index >= 0) this.cards.splice(index, 1);
    },
    update: function update(card) {
      var index = this.cards.findIndex(function (item) {
        return item.id === card.id;
      });
      if (index >= 0) {
        this.cards[index] = card;
        this.sort();
      }
    },
    updateCard: function updateCard(_ref) {
      var id = _ref.id,
        update = _ref.update;
      var card = this.cards.find(function (card) {
        return card.id === id;
      });
      if (card) {
        Object.assign(card, update);
        this.sort();
      }
    },
    hydrate: function hydrate() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (_this.$nuxt.$auth.user) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", _this.hydrated = true);
            case 2:
              if (!_this.hydrating) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              _this.hydrating = true;
              _context.next = 7;
              return _this.$nuxt.$axios.$get('/reportcard/list', {
                params: {
                  noEvents: false
                },
                progress: false
              }).catch(function () {});
            case 7:
              data = _context.sent;
              if (data && data.cards) _this.cards = data.cards;
              _this.hydrated = true;
              _this.hydrating = false;
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    setStatus: function setStatus(_ref2) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var id, status, card;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              id = _ref2.id, status = _ref2.status;
              card = _this2.cards.find(function (card) {
                return card.id == id;
              });
              if (card) {
                _context2.next = 4;
                break;
              }
              return _context2.abrupt("return");
            case 4:
              card = _this2.$nuxt.$structuredClone(card);
              _this2.updateCard({
                id: id,
                update: {
                  status: status
                }
              });
              _this2.$nuxt.$axios.$post('/reportcard/setstatus', {
                id: id,
                status: status
              }, {
                progress: false
              }).then(function (res) {
                var icon = 'icon-ic-restore';
                switch (status) {
                  case "archived":
                    icon = 'icon-ic-archive';
                    break;
                  default:
                    icon = 'icon-ic-restore';
                }
                _this2.$nuxt.$toastStore.add({
                  title: _this2.$nuxt.i18n.t("courseSettings.".concat(status, "Toast.title"), {
                    name: card.course.name
                  }),
                  text: _this2.$nuxt.i18n.t("courseSettings.".concat(status, "Toast.text")),
                  icon: icon
                });
              }).catch(function (err) {
                console.log(err);
                _this2.updateCard({
                  id: id,
                  update: {
                    status: card.status
                  }
                });
                _this2.$nuxt.$toastStore.add({
                  title: _this2.$nuxt.i18n.t("courseSettings.".concat(status, "Toast.titleFail"), {
                    name: card.course.name
                  }),
                  text: _this2.$nuxt.i18n.t("courseSettings.toastTextFail"),
                  icon: 'icon-ic-dismiss',
                  autoClose: 9000
                });
              });
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    socketUpdate: function socketUpdate(card) {
      var index = this.cards.findIndex(function (item) {
        return item.id === card.id;
      });
      if (index < 0) this.cards.push(card);else this.cards[index] = card;
      this.sort();
    }
  }
});